import styled from 'styled-components';

import { theme } from '_constants/theme';

const { devices, fontSizes, colors, spaces } = theme;

// eslint-disable-next-line prettier/prettier, react/display-name
const StyledTestimonial = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spaces.large2X - 2}px ${spaces.large2X - 2}px;
  gap: ${spaces.large2X - 2}px;
  background: linear-gradient(
    180deg,
    ${colors.indigo[100]} 0%,
    rgba(240, 243, 250, 0) 100%
  );
  border-radius: 30px;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  @media ${devices.tablet} {
    border-radius: ${spaces.regular}px;
    padding-top: ${spaces.regular}px;
    padding-bottom: ${spaces.regular}px;
    padding-left: ${spaces.regular}px;
    padding-right: ${spaces.regular}px;
  }
`;
const StyledDescription = styled.div`
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 400;
  font-size: ${fontSizes.medium}px;
  line-height: 150%;
  color: ${colors.gray[700]};
  @media ${devices.tablet} {
    font-size: ${fontSizes.regular}px;
  }
`;
const StyledAuthor = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .author {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-size: ${fontSizes.medium}px;
    line-height: 150%;
    text-transform: uppercase;
    color: ${colors.gray[800]};
    margin-bottom: ${spaces.small2X}px;

    .title {
      font-family: 'Aeonik';
      font-style: normal;
      font-weight: 400;
      font-size: ${fontSizes.regular}px;
      line-height: 150%;
      color: ${colors.gray[700]};
    }

    @media ${devices.tablet} {
      .author {
        font-size: ${fontSizes.regular}px;
      }
      .title {
        font-size: ${fontSizes.small}px;
      }
    }
  }
`;
const Testimonial = ({ description, author, title }) => {
  return (
    <StyledTestimonial>
      <StyledDescription>{description}</StyledDescription>
      <StyledAuthor>
        <div className="author">{author}</div>
        <div className="title">{title}</div>
      </StyledAuthor>
    </StyledTestimonial>
  );
};

export default Testimonial;
